import gql from 'graphql-tag'

export const presetCreate = gql`
  mutation presetCreate($data: PresetCreateInput!) {
    presetCreate(input: $data) {
      success
    }
  }
`
